import { FC } from 'react';
import { noOp } from '../../lib/utils';
import { InputError } from '../InputError';
import { Label } from '../Label';
import { Radio } from '../Radio';

export type RadioGroupProps = {
  label?: string;
  initialSelection: string | null;
  radioOptions: {
    value: string;
    label: string;
    disabled?: boolean;
    error?: boolean;
  }[];
  errorMessage?: string;
  onChange: (selectedValue: string | null) => string | void;
};

export const RadioGroup: FC<RadioGroupProps> = ({
  label,
  initialSelection,
  radioOptions,
  errorMessage,
  onChange = noOp,
}: RadioGroupProps) => (
  <>
    {label ? <Label content={label} /> : null}
    <div className="flex w-full space-x-6">
      {radioOptions.map((radio) => (
        <Radio
          key={radio.label}
          disabled={radio.disabled}
          error={radio.error}
          value={radio.value}
          label={radio.label}
          initialSelected={initialSelection === radio.value}
          onSelect={(isSelected) => {
            onChange(isSelected ? radio.value : null);
          }}
        />
      ))}
    </div>
    {errorMessage && <InputError text={errorMessage} />}
  </>
);
